<template>
  <!-- 个人资料 -->
  <el-form
    ref="form"
    :model="info"
    label-width="110px"
    label-position="left"
    id="personalItem"
  >
    <el-form-item label="姓名" prop="clientName">
      <span class="defaultClass">{{info.clientName}}</span>
    </el-form-item>
    <el-form-item label="身份" prop="identityType">
      <span
        class="defaultClass"
      >{{info.identityType == 0 ? '学生' :info.identityType == 1 ? '教职工' :info.identityType == 2 ? '公司员工' : '-' }}</span>
    </el-form-item>
    <el-form-item label="邮箱" prop="email">
      <span class="defaultClass">{{info.email}}</span>
    </el-form-item>
    <el-form-item label="所在省市" prop="province">
      <span class="defaultClass">{{info.province}}</span>
    </el-form-item>
    <el-form-item label="所在高校" prop="colleges" v-if="info.identityType != 2">
      <span class="defaultClass">{{info.colleges|| '暂无'}}</span>
    </el-form-item>
    <el-form-item label="所在院系" prop="faculty" v-if="info.identityType != 2">
      <span class="defaultClass">{{info.faculty || '暂无'}}</span>
    </el-form-item>
    <el-form-item label="所在校区" prop="campus" v-if="info.identityType != 2">
      <span class="defaultClass">{{info.campus|| '暂无'}}</span>
    </el-form-item>
    <el-form-item label="所在企业" prop="companyName" v-if="info.identityType == 2">
      <span class="defaultClass">{{info.companyName|| '暂无'}}</span>
    </el-form-item>
    <el-form-item label="详细地址" prop="address">
      <span class="defaultClass">{{info.address|| '暂无'}}</span>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  props: {
    info: {
      type: [Object, Array],
      default: () => {}
    }
  },

  data() {
    return {};
  },
  methods: {}
};
</script>